import { configureStore } from "@reduxjs/toolkit";
import uiSlice from "../reducers/ui";
import productsSlice from "../reducers/product";
import authSlice from "../reducers/auth";

export const store = configureStore({
  reducer: { ui: uiSlice, products: productsSlice, auth: authSlice },
});
